import React from "react";

const AdminStatCard = ({ icon: Icon, label, value }) => {
  return (
    <div className="rounded-xl border border-[#F3F4F6] bg-white p-4">
      <div className="mb-2 flex items-center gap-1.5">
        {Icon && <Icon size={14} className="text-[#6B7280]" />}
        <span className="text-xs text-[#6B7280]">{label}</span>
      </div>
      <span className="text-[28px] font-bold text-[#111827]">
        {value?.toLocaleString() ?? 0}
      </span>
    </div>
  );
};

export default AdminStatCard;
